<template>
    <div>
        <i v-b-toggle.sidebar-1 style="color: white;" class="fas fa-bars fa-2x"></i>
        <b-sidebar id="sidebar-1" width="350px" bg-variant="dark" class="bg-dark" text-variant="light" no-header shadow>
            <template #default="{ hide }">
                <b-row class="sticky-header shadow-sm">
                    <b-col cols="12" class="p-2 d-flex justify-content-around no-wrap">
                        <div>
                            <b-img :src="'/imgs/Logo-branca.png'" class="img" />
                        </div>
                        <div class="d-flex align-items-center">
                            <i class="fas fa-times fa-1x" @click="hide" style="cursor: pointer;"></i>
                        </div>
                    </b-col>
                </b-row>

                <div class="menu-scroll-area"> 
                    <b-row class="p-2">
                        <b-col style="cursor: pointer;" cols="12" class="mb-2 align-self-center itens rounded p-0" v-for="(menu, index) in menus" :key="index" @click="menu.childs ? menu.visible = !menu.visible : abrirLink(menu.rota)">
                            <div v-if="menu.childs">
                                <div v-b-toggle="'collapse-'+index" class="d-flex justify-content-between align-items-center p-2">
                                    <div class="d-flex align-items-center">
                                        <div style="width: 25px; height: 25px;" class="mx-1">
                                            <i :class="`fas ${menu.icon} fa-1x`"></i>
                                        </div>
                                        <h5 class="m-0">{{ menu.title }}</h5>
                                    </div>
                                    <i :class="`fas fa-arrow-${menu.visible ? 'up' : 'down'} fa-1x`"></i>
                                </div>
                                <b-collapse :id="'collapse-'+index">
                                    <div v-for="(child, index_child) in menu.childs" class="mt-2 py-2 sub-item" :key="index_child">
                                        <div class="pl-5" @click.stop="abrirLink(child.rota)">{{child.title}}</div>
                                    </div>
                                </b-collapse>
                            </div>
                            <div @click.stop="abrirLink(menu.rota)" class="d-flex align-items-center p-2" v-else>
                                <div style="width: 25px; height: 25px;" class="mx-1">
                                    <i :class="`fas ${menu.icon} fa-1x`"></i>
                                </div>
                                <h5 class="m-0">{{menu.title}}</h5>
                            </div>
                        </b-col>
                    </b-row>
                </div>
                
            </template>
        </b-sidebar>
    </div>
</template>

<script>
export default {
    data() {
        return {
            menus: []
        }
    },
    methods: {
        getMenus(){
            axios
                .get("/get_menus")               
                .then(resp => {
                    if(resp.data){
                        var obj = {}
                        resp.data.forEach(element => {
                            if(!element.rota){
                                obj = {
                                    title: element.label,
                                    icon: element.icon,
                                    visible: false,
                                    childs: []
                                }

                                element.submenus.forEach(element => {
                                    obj.childs.push({
                                        title: element.label,
                                        rota: element.rota
                                    })
                                });

                                this.menus.push(obj)
                            }else{
                                obj = {
                                    title: element.label,
                                    icon: element.icon,
                                    rota: element.rota
                                }

                                this.menus.push(obj)
                            }
                        })
                    }
                })
                .catch(error => {
                    // console.error("Erro ao buscar menus:", error)
                })
        },
        abrirLink(rota){
            window.open(rota, '_self');
        }
    },
    mounted(){
        this.getMenus()
    }
}
</script>

<style lang="scss" scoped>
    .bg-dark{
        background-color: #3f5772 !important;
    }
    .itens:hover{
        background-color: #45607e;

        .sub-item:hover{
            background-color: #4f6f92;
        }
    }

    .sticky-header {
        background-color: #3f5772 !important; 
        position: sticky;
        top: 0;
        z-index: 1000;
    }

    .menu-scroll-area {
        height: calc(100vh - 80px);
        padding-bottom: 20px;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/adm_vertical_navbar/Main.vue